import { render, staticRenderFns } from "./InspectionEvidence.vue?vue&type=template&id=4cc6f578&"
import script from "./InspectionEvidence.vue?vue&type=script&lang=js&"
export * from "./InspectionEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports